/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown> }} Ccsl_Export_Metadata_Video_IncodeInputs */



/**
* | output |
* | --- |
* | "Video Incode: {timecode}" |
*
* @param {Ccsl_Export_Metadata_Video_IncodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_metadata_video_incode = /** @type {((inputs: Ccsl_Export_Metadata_Video_IncodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Metadata_Video_IncodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Incode video : ${i?.timecode}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Video-Inkodierung: ${i?.timecode}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Codice video: ${i?.timecode}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Видеокодек: ${i?.timecode}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Codificación de vídeo: ${i?.timecode}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`视频编码：${i?.timecode}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ビデオインコード: ${i?.timecode}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वीडियो इनकोड: ${i?.timecode}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Codificação de vídeo: ${i?.timecode}`)
	return /** @type {LocalizedString} */ (`Video Incode: ${i?.timecode}`)
});